import { setOpenBulkEndAssignmentModal } from 'modules/subassignmentManagement/components/BulkEndAssignment/store/actions';
import { combineReducers } from 'redux';
import { singleValueReducer } from 'store/reducerUtils';

const isOpenBulkEndModal = singleValueReducer(setOpenBulkEndAssignmentModal.action, false);

export const endSubassignments = combineReducers({
    isOpenBulkEndModal,
});
